export default "__VITE_ASSET__CSLGVnjL__"